import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'; // Assuming you're using React Router
import './legalPage.scss'; // Import CSS file for styling if needed
import { useTranslation } from '../../services/LanguageContext'; // Import useTranslation hook

const LegalPage = () => {
    const { pageType } = useParams(); // Get the URL parameter (e.g., agb, impressum, datenschutz)
    const { language, t } = useTranslation(); // Get translation hook
    const [legalPage, setLegalPage] = useState(null);
    const [translatedContent, setTranslatedContent] = useState(null); // State to store translated content
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLegalPage = async () => {
            try {
                const response = await fetch('https://find-together-api.sslbeta.de/api/Support/getLegalPages');
                const data = await response.json();
                
                // Find the page data based on the URL parameter
                const pageData = data.find(page => page.type.toLowerCase() === pageType.toLowerCase());

                if (!pageData) {
                    setLegalPage(null);
                    setLoading(false);
                    return;
                }

                setLegalPage(pageData); // Set original content
                
                // For now, use original content (German) - you can add legal page translation keys to your GraphQL API later
                setTranslatedContent(pageData.content);
                
            } catch (error) {
                console.error('Error fetching legal page:', error);
                // Use fallback content if API fails
                setTranslatedContent(t('legal_content_fallback', 'Rechtliche Inhalte werden geladen...'));
            } finally {
                setLoading(false);
            }
        };

        fetchLegalPage();
    }, [pageType, language, t]);

    if (loading) {
        return <p>{t('legal_loading', 'Laden...')}</p>;
    }

    if (!legalPage) {
        return <p>{t('legal_not_found', 'Seite nicht gefunden.')}</p>;
    }

    return (
        <div className='container inner-page-container'>
            <h2 className='text-left my-5'>{legalPage.title}</h2>
            <div 
                className="legal-content"
                dangerouslySetInnerHTML={{ __html: translatedContent }} 
            />
        </div>
    );
};

export default LegalPage;
